import { TOptions } from 'i18next';
import { createContext } from 'react';

type ExtraOpt = {
  sex?: 'female' | 'male';
  conjugation?: boolean;
};

export type Options = TOptions & ExtraOpt;

interface TranslatorContextType {
  t: (message: string, options?: Options) => string;
  language: string;
  changeLanguage: (language: string) => void;
}

const TranslatorContext = createContext<TranslatorContextType>({
  t: () => '',
  language: '',
  changeLanguage: () => '',
});

export default TranslatorContext;
